export default __webpack_public_path__ + "static/media/cart.b78dabf0.svg";